import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Router from './router';
import { HashRouter } from "react-router-dom";

function App() {

  
  return (    
      <Router history={HashRouter}/>        
  );
}

export default App;
